"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var ModalAlert_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalAlert"));
var ConfirmationModal_1 = __importDefault(require("./ConfirmationModal"));
var ConfirmationModalContext_1 = __importDefault(require("./ConfirmationModalContext"));
var ConfirmationModalWrapper = function (_a) {
    var children = _a.children;
    var _b = __read(react_1.default.useState(null), 2), confirmModalState = _b[0], setConfirmModalState = _b[1];
    var _c = confirmModalState !== null && confirmModalState !== void 0 ? confirmModalState : {}, noCancel = _c.noCancel, buttonType = _c.buttonType, heading = _c.heading, onClick = _c.onClick, onClose = _c.onClose, buttonLabel = _c.buttonLabel;
    var confirmText = confirmModalState === null || confirmModalState === void 0 ? void 0 : confirmModalState.confirmText;
    if (!confirmText && (confirmModalState === null || confirmModalState === void 0 ? void 0 : confirmModalState.renderConfirmText)) {
        var ConfirmTextComponent = confirmModalState === null || confirmModalState === void 0 ? void 0 : confirmModalState.renderConfirmText;
        confirmText = (0, jsx_runtime_1.jsx)(ConfirmTextComponent, { onClick: onClick, onClose: onClose });
    }
    return ((0, jsx_runtime_1.jsxs)(ConfirmationModalContext_1.default.Provider, __assign({ value: setConfirmModalState }, { children: [children, !!confirmModalState && (!noCancel
                ? (0, jsx_runtime_1.jsx)(ConfirmationModal_1.default, __assign({ open: true }, confirmModalState))
                : ((0, jsx_runtime_1.jsx)(ModalAlert_1.default, { open: true, status: buttonType === 'green' ? 'success' : 'error', title: heading !== null && heading !== void 0 ? heading : '', description: confirmText, buttonAction: onClick, buttonText: buttonLabel, onClose: onClose })))] })));
};
exports.default = ConfirmationModalWrapper;
